<div class="main">
    <div class="side-menu" [ngClass]="{'menuClose': !isMenuOpen}">
        <gps-tracker-demo-side-nav [isMenuOpen]="isMenuOpen" (menuToggle)="menuToggle($event)" />
    </div>
    <div class="content">
        <gps-tracker-top-nav [isMenuOpen]="isMenuOpen" (menuToggle)="menuToggle($event)" />
        <div class="main-content">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<div (click)="menuToggle(false)" [ngClass]="{'drawer-overlay': isMenuOpen}"></div>